import React from 'react';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import { Route } from 'react-router-dom';

// tslint:disable space-in-parens
const AsyncWriteAReview = Load(() => import(/* webpackChunkName: "write-review" */'./containers/WriteAReviewContainer'));
const AsyncSuggestionsContainer = Load(() => import(/* webpackChunkName: "write-review" */'./containers/SuggestionsContainer'));
const AsyncFeedbackContainer = Load(() => import(/* webpackChunkName: "write-review" */'./containers/FeedbackContainer'));
// tslint:enable space-in-parens

const WriteReviewRoutes = [
  (
    <NavigationableLayout
      key="review-suggestions"
      nonFixedNavbar
      path={`${basePath}/manage/review/:tripId/suggestions`}
      component={AsyncSuggestionsContainer}
      hideFooter
      showBottomNavigation
    />
  ),
  (
    <Route
      key="review-more-feedback"
      path={`${basePath}/manage/review/:tripId/feedback`}
      component={AsyncFeedbackContainer}
    />
  ),
  (
    <Route
      key="write-a-review"
      path={`${basePath}/manage/review/:tripId`}
      component={AsyncWriteAReview}
    />
  ),
];

export default WriteReviewRoutes;
